export default function initPopup() {
    try {
        const signupForm = document.querySelector('.newsletter-signup');
        const collapseButton = document.getElementById('collapse-button');
        const fakeHeader = document.getElementById('fake-header');

        if (!signupForm) return;

        function setCookie(name, value, days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
        }

        function getCookie(name) {
            const nameEQ = `${name}=`;
            const cookies = document.cookie.split(';');
            for (let c of cookies) {
                c = c.trim();
                if (c.indexOf(nameEQ) === 0) {
                    return c.substring(nameEQ.length);
                }
            }
            return null;
        }

        const wasCollapsed = getCookie('newsletter_collapsed') === 'true';

        signupForm.classList.remove('expanded');

        if (!wasCollapsed) {
            setTimeout(() => {
                signupForm.classList.add('expanded');
            }, 5000);
        }

        if (fakeHeader) {
            fakeHeader.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                signupForm.classList.add('expanded');
                setCookie('newsletter_collapsed', 'false', 30);
            });
        }

        if (collapseButton) {
            collapseButton.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                signupForm.classList.remove('expanded');
                setCookie('newsletter_collapsed', 'true', 30);
                
                if (typeof gtag === "function") {
                    gtag('event', 'newsletter_dismiss', {
                        'event_category': 'engagement'
                    });
                }
            });
        }

    } catch (error) {
        console.error('Newsletter popup error:', error);
    }
}